export default __webpack_public_path__ + "static/media/IconPenNibActive.8e07906c.svg";